import { FC } from 'react';

const ActionIconLocation: FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.37336 3.50283C2.7456 4.60528 2.91963 5.98118 3.82068 6.90424L6 9.13681L8.17932 6.90424C9.08037 5.98118 9.2544 4.60528 8.62664 3.50283C7.48565 1.49906 4.51435 1.49906 3.37336 3.50283ZM6 12L2.3895 8.30128C0.869489 6.74413 0.563495 4.39558 1.63537 2.51319C3.54345 -0.837728 8.45655 -0.837729 10.3646 2.51319C11.4365 4.39558 11.1305 6.74413 9.6105 8.30128L6 12Z"
      fill="currentColor"
    />
    <path
      d="M7.5 5C7.5 5.82843 6.82843 6.5 6 6.5C5.17157 6.5 4.5 5.82843 4.5 5C4.5 4.17157 5.17157 3.5 6 3.5C6.82843 3.5 7.5 4.17157 7.5 5Z"
      fill="currentColor"
    />
  </svg>
);

export { ActionIconLocation };
